export default __webpack_public_path__ + "static/media/White_Cloud_large_10.afbfb65e.jpg";